<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/report/bankstatement")
          i.fa.fa-poll-h
          span.ml-1 {{ $t("ui.bank_statement") }}
      b-breadcrumb-item(v-if="currOperator && pageLvl != 'opr' && getAccountType == 3")
        i.fa.fa-user
        span.ml-1 {{ currOperator.account_id }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.row.mb-1(v-if="pageLvl == 'opr'")
                div.col-md-3.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.icon-user
                    DebounceInput(required autofocus type="text" v-model="search" :placeholder="$t('message.search_by_id')")
                div.col-md-2.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getOperatorList()"
                    variant="success"
                    size="sm"
                    )
              div.row(v-if="pageLvl == 'report' && currOperator")
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.month") }}
                    //- b-form-select(:options="monthOpt" v-model="selectedMonth" @input="getBankStatement")
                    b-form-select(:options="monthOpt" v-model="selectedMonth")
                div.col-md-4.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $tc("ui.banks", 1) }}
                    BankAccountList(
                      ref="bank"
                      size="sm"
                      required
                      type="array"
                      v-model="bank"
                      :disabled="loading"
                      :item="currOperator.account_id"
                      filterBankAccStatus=false
                    )
                div.col-md-2.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getBankStatement()"
                    variant="success"
                    size="sm"
                    )
        div.card-body
          div.mb-1(v-if="pageLvl == 'opr' && getAccountType == 3")
            div.row.mb-1
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalOprRow"
                  :per-page="getPageSize"
                  v-model="currentOprPage"
                  @input="changedOprPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedOprPageSize")
          div.mb-1(v-if="pageLvl == 'report'")
            div.mb-1(v-if="getAccountType == 3")
              SubmitButton(
                :loading="loading"
                icon="icon-arrow-left"
                :text="$t('ui.back')"
                type="button"
                @click="backToOperatorLvl"
                variant="secondary"
                size="sm"
                ).mb-1.mr-1
            div.row.mb-1
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalReportRow"
                  :per-page="getPageSize"
                  v-model="currentReportPage"
                  @input="changedReportPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedReportPageSize")
          div.row.clusterize
            div.col-md-12(v-if="pageLvl=='opr' && getAccountType == 3")
              .clusterize-scroll
                table.tablex(style="width: 100%;")
                  thead
                    tr
                      th.sticky-position(width="3%")
                        span #
                      th.sticky-position.sortable(width="10%" @click="sortOrder('account_id', 'opr')")
                        span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                        i(:class="changeSortKey('account_id', 'opr')")
                      th.sticky-position.sortable(width="10%" @click="sortOrder('profile_id', 'opr')")
                        span(:title="$t('ui.profile_id')") {{ $t('ui.profile_id') }}
                        i(:class="changeSortKey('profile_id', 'opr')")
                      th.sticky-position.sortable(width="23%" @click="sortOrder('full_name', 'opr')")
                        span(:title="$t('ui.full_name')") {{ $t("ui.full_name") }}
                        i(:class="changeSortKey('full_name', 'opr')")
                      th.sticky-position(width="11%")
                        span(:title="$t('ui.contact_phone')") {{ $t("ui.contact_phone") }}
                      th.sticky-position(width="15%")
                        span(:title="$t('ui.login_ip')") {{ $t("ui.login_ip") }}
                      th.sticky-position(width="7%")
                        span(:title="$t('ui.status')") {{ $t("ui.status") }}
                      th.text-right.sticky-position.sortable(width="13%" @click="sortOrder('created_date', 'opr')")
                        span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                        i(:class="changeSortKey('created_date', 'opr')")
                  tbody.clusterize-content
                    tr(v-if="filteredOperatorList.length == 0")
                      td(colspan="8").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in filteredOperatorList")
                      td
                        span(:title="((currentOprPage - 1) * getPageSize + index + 1)") {{ ((currentOprPage - 1) * getPageSize + index + 1) }}
                      td
                        span
                          b-link.clickable(href="javascript:void(0);" @click="setOperatorAccId(item, true)" :title="item.account_id") {{ item.account_id }}
                      td
                        span(:title="item.profile_id") {{ item.profile_id }}
                      td
                        span(:title="item.full_name") {{ item.full_name }}
                      td
                        span(:title="item.contact_phone") {{ item.contact_phone }}
                      td
                        span(:title="item.last_login_ip") {{ item.last_login_ip }}
                      td
                        span(:title="item.status") {{ item.status }}
                      td.text-right
                        span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
            div.col-md-12(v-if="currOperator && pageLvl== 'report'")
              .clusterize-scroll
                table.tablex(style="width: auto;min-width: 50%;")
                  thead
                    tr
                      th.sticky-position(width="8%")
                        span #
                      th.sticky-position.sortable(width="18%" @click="sortOrder('transfer_date', 'report')")
                        span(:title="$t('ui.transfer_date')") {{ $t('ui.transfer_date') }}
                        i(:class="changeSortKey('transfer_date', 'report')")
                      th.sticky-position(width="38%")
                        span(:title="$t('ui.detail')") {{ $t('ui.detail') }}
                      th.sticky-position(width="18%")
                        span(:title="$t('ui.credit')") {{ $t('ui.credit') }}
                      th.sticky-position.sortable(width="18%")
                        span(:title="$t('ui.debit')") {{ $t('ui.debit') }}
                  tbody.clusterize-content
                    tr(v-if="reportList.length == 0")
                      td(:colspan="5").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in reportList")
                      td
                        span {{ ((currentReportPage - 1) * getPageSize + index + 1) }}
                      td
                        span(:title="$moment(item.transfer_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.transfer_date).format('YYYY-MM-DD, HH:mm:ss') }}
                      td
                        span.font-weight-bold {{ getDetailTitle(item.transfer_type, item.sender_id) }}

                        br(v-if="item.transfer_type == 'DEPOSIT' && item.transfer_method")
                        span(v-if="item.transfer_type == 'DEPOSIT' && item.transfer_method") {{ item.transfer_method }}
                        br(v-if="(item.transfer_type == 'DEPOSIT' && item.sender_id) || (ownAccTransfer(item) == 'DEPOSIT' && item.transfer_type == 'TRANSFER')")
                        span(v-if="(item.transfer_type == 'DEPOSIT' && item.sender_id) || (ownAccTransfer(item) == 'DEPOSIT' && item.transfer_type == 'TRANSFER')") {{ item.sender_id }}

                        br(v-if="ownAccTransfer(item) == 'DEPOSIT' && item.transfer_type == 'TRANSFER' && item.sender_bank_id")
                        span(v-if="ownAccTransfer(item) == 'DEPOSIT' && item.transfer_type == 'TRANSFER' && item.sender_bank_id") {{ item.sender_bank_id }}
                        br(v-if="ownAccTransfer(item) == 'DEPOSIT' && item.transfer_type == 'TRANSFER' && item.sender_bank_acc_no")
                        span(v-if="ownAccTransfer(item) == 'DEPOSIT' && item.transfer_type == 'TRANSFER' && item.sender_bank_acc_no") {{ item.sender_bank_acc_no }}
                        br(v-if="ownAccTransfer(item) == 'DEPOSIT' && item.transfer_type == 'TRANSFER' && item.sender_bank_acc_holder")
                        span(v-if="ownAccTransfer(item) == 'DEPOSIT' && item.transfer_type == 'TRANSFER' && item.sender_bank_acc_holder") {{ item.sender_bank_acc_holder }}

                        br(v-if="(item.transfer_type == 'WITHDRAWAL' && item.recipient_id) || (ownAccTransfer(item) == 'WITHDRAWAL' && item.transfer_type == 'TRANSFER')")
                        span(v-if="(item.transfer_type == 'WITHDRAWAL' && item.recipient_id) || (ownAccTransfer(item) == 'WITHDRAWAL' && item.transfer_type == 'TRANSFER')") {{ item.recipient_id }}
                        br(v-if="(item.transfer_type == 'WITHDRAWAL' && item.recipient_bank_id) || (ownAccTransfer(item) == 'WITHDRAWAL' && item.transfer_type == 'TRANSFER')")
                        span(v-if="(item.transfer_type == 'WITHDRAWAL' && item.recipient_bank_id) || (ownAccTransfer(item) == 'WITHDRAWAL' && item.transfer_type == 'TRANSFER')") {{ item.recipient_bank_id }}
                        br(v-if="(item.transfer_type == 'WITHDRAWAL' && item.recipient_bank_acc_no) || (ownAccTransfer(item) == 'WITHDRAWAL' && item.transfer_type == 'TRANSFER')")
                        span(v-if="(item.transfer_type == 'WITHDRAWAL' && item.recipient_bank_acc_no) || (ownAccTransfer(item) == 'WITHDRAWAL' && item.transfer_type == 'TRANSFER')") {{ item.recipient_bank_acc_no }}
                        br(v-if="(item.transfer_type == 'WITHDRAWAL' && item.recipient_bank_acc_holder) || (ownAccTransfer(item) == 'WITHDRAWAL' && item.transfer_type == 'TRANSFER')")
                        span(v-if="(item.transfer_type == 'WITHDRAWAL' && item.recipient_bank_acc_holder) || (ownAccTransfer(item) == 'WITHDRAWAL' && item.transfer_type == 'TRANSFER')") {{ item.recipient_bank_acc_holder }}

                        br(v-if="item.ref_id")
                        span.text-italic(v-if="item.ref_id") {{ item.ref_id }}
                        br(v-if="item.remark")
                        span.text-italic(v-if="item.remark") {{ item.remark }}
                      td
                        span.font-weight-bold(v-if="(item.transfer_type == 'DEPOSIT') || (ownAccTransfer(item) == 'DEPOSIT' && item.transfer_type == 'TRANSFER')" :title="$n(item.transfer_amount, 'currency')") {{ $n(item.transfer_amount, 'currency') }}
                      td
                        span.font-weight-bold.text-danger(v-if="(item.transfer_type == 'WITHDRAWAL') || (ownAccTransfer(item) == 'WITHDRAWAL' && item.transfer_type == 'TRANSFER')" :title="$n(item.transfer_amount * -1, 'currency')") {{ $n(item.transfer_amount * -1, 'currency') }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import BankAccountList from "@/library/BankAccountList";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    BankAccountList
  },
  data: () => ({
    loading: false,
    operatorList: [],
    reportList: [],
    currentOprPage: 1,
    totalOprRow: 0,
    currentReportPage: 1,
    totalReportRow: 0,
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    pageLvl: 'opr',
    currOperator: null,
    startDate: null,
    endDate: null,
    bank: '',
    monthOpt: [],
    selectedMonth: null,
    currentBank: null,
    oprSortKey: "account_id",
    oprSortType: "asc",
    reportSortKey: "transfer_date",
    reportSortType: "desc"
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    filteredOperatorList() {
      return this.operatorList;
    },
    getAccountType() {
      if (this.$store.getters.account[0])
        return this.$store.getters.account[0].account_type;

      return 0;
    }
  },
  mounted: function() {
    this.getDateOpt();
    if(this.$store.getters.account[0]) {
      if (this.$store.getters.account[0].account_type == 2) {
        this.currOperator = this.$store.getters.account[0];
        this.pageLvl = 'report';
      } else if (this.$store.getters.account[0].account_type == 3) {
        this.getOperatorList(true);
      }
    }
  },
  methods: {
    sortOrder(key, type) {
      if (type == 'opr') {
        if (this.oprSortKey == key)
          this.oprSortType = this.oprSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.oprSortKey = key;
          this.oprSortType = 'asc';
        }
        this.getOperatorList(true);
      } else if (type == 'report') {
        if (this.reportSortKey == key)
          this.reportSortType = this.reportSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.reportSortKey = key;
          this.reportSortType = 'asc';
        }
        this.getBankStatement(true);
      }
    },
    changeSortKey(key, type) {
      if (type == 'opr') {
        if (this.oprSortKey != key)
          return 'fas fa-sort';
        else if (this.oprSortKey == key && this.oprSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.oprSortKey == key && this.oprSortType == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'report') {
        if (this.reportSortKey != key)
          return 'fas fa-sort';
        else if (this.reportSortKey == key && this.reportSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.reportSortKey == key && this.reportSortType == 'desc')
          return 'fa fa-sort-down';
      }
    },
    getDateOpt() {
      for(var i = 0; i > -3; i--) {
        this.monthOpt.push(this.$moment(new Date).add(i, 'month').format('YYYY-MM'));
      }

      this.selectedMonth = this.$moment(new Date).format('YYYY-MM');
    },
    ownAccTransfer(item) {
      if (this.currentBank.split(' - ')[0].trim() == item.sender_bank_id && this.currentBank.split(' - ')[1].trim() == item.sender_bank_acc_no)
        return 'WITHDRAWAL';

      if (this.currentBank.split(' - ')[0].trim() == item.recipient_bank_id && this.currentBank.split(' - ')[1].trim() == item.recipient_bank_acc_no)
        return 'DEPOSIT';

      return '';
    },
    getDetailTitle(type, sender) {
      if (sender.toUpperCase() == 'SYSTEM')
        return 'Balance Adjustment';
      if (type.toUpperCase() == 'DEPOSIT')
        return 'Transfer From A/C';
      if (type.toUpperCase() == 'WITHDRAWAL')
        return 'Transfer To A/C';

      return 'Own Account Transfer';
    },
    backToOperatorLvl() {
      this.pageLvl = "opr";
      this.search = "";
      this.bank = '';
      this.reportList = [];
      this.totalReportRow = 0;
      this.currOperator = null;
      this.selectedMonth = this.$moment(new Date).format('YYYY-MM')
    },
    getOperatorList: function(isSearch) {
      this.pageLvl = 'opr';

      let url = config.accountListUrl();

      if (isSearch) this.currentOprPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        sort_key: this.oprSortKey,
        sort_type: this.oprSortType,
        page_number: this.currentOprPage,
        page_size: this.getPageSize
      };


      if (this.search.trim() != '') {
        json.search_id = this.search;
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.operatorList = response.data.dt;
                this.totalOprRow = this.operatorList.length > 0 ? this.operatorList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    setOperatorAccId: function (item) {
      this.currOperator = item;
      this.search = "";
      this.pageLvl = 'report';
      // this.getBankStatement(true);
    },
    getBankStatement: function(isSearch) {
      this.pageLvl = 'report';

      this.currentBank = this.bank;

      let url = config.bankStatementOperatorUrl();

      if (isSearch) this.currentReportPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        source_account_id: this.$store.getters.accountId,
        target_account_id: this.currOperator.account_id,
        bank_id: this.bank == '' ? null : this.bank.split(' - ')[0].trim(),
        bank_acc_no: this.bank == '' ? null : this.bank.split(' - ')[1].trim(),
        start_date: this.$moment(this.selectedMonth).startOf("month").format("YYYY-MM-DD"),
        end_date: this.$moment(this.selectedMonth).endOf("month").format("YYYY-MM-DD"),
        sort_type: this.reportSortType,
        page_number: this.currentReportPage,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.reportList = response.data.dt;
                this.totalReportRow = this.reportList.length > 0 ? this.reportList[0].totalrows : 0;
              } else {
                if (this.feedback.status != 'permission_denied') {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
                else {
                  this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedOprPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentOprPage = 1;
      this.getOperatorList(true);
    },
    changedOprPage: function(pageNo) {
      this.currentOprPage = pageNo;
      this.getOperatorList();
    },
    changedReportPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentReportPage = 1;
      this.getBankStatement(true);
    },
    changedReportPage: function(pageNo) {
      this.currentReportPage = pageNo;
      this.getBankStatement();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
.text-italic {
  font-style: italic !important;
}
</style>